// extracted by mini-css-extract-plugin
export default {"modal":"SuccessModal_modal__GSGIn","modal_active":"SuccessModal_modal_active__OpO9+","img":"SuccessModal_img__41TaJ","text":"SuccessModal_text__F1AUd"};